// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from "../../../store/store";
import {
  fetchBlockById,
  fetchBlockScripts,
} from "../../../store/shows/showsActions";
import { clearBlock } from "../../../store/shows/showsSlice";
import { clearScripts } from "../../../store/scripts/scriptsSlices";

export async function blockLoader({ params }) {
  const { showId, blockId } = params;
  if (!blockId) {
    return null;
  }

  // Dispatch actions to fetch block and clear scripts
  await store.dispatch(clearBlock());
  await store.dispatch(fetchBlockById(blockId));
  await store.dispatch(fetchBlockScripts({ showId, blockId }));
  store.dispatch(clearScripts());

  return null;
}

blockLoader.hydrate = true;
